"use strict";
// import React from 'react';
// import styles from './FormFieldPhone.module.scss';
// import { useNumberPhone } from '../../hook/useNumberPhone';
// import type { FormFieldPhoneProps } from '../../interfaces/form.interface';
// import type { FieldValues, Path } from 'react-hook-form';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldPhone = void 0;
// export var FormFieldPhone = <T extends FieldValues>(props: FormFieldPhoneProps<T>): React.JSX.Element => {
//     var { id, register, isError } = props;
//     var [value, handleKeyDown, setInputRef] = useNumberPhone();
//     return (
//         <label className={styles.label_phone} htmlFor={id}>
//             <input
//                 {...register('phone' as Path<T>, {
//                     required: true,
//                     pattern: { value: /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/, message: 'Введите номер' },
//                 })}
//                 autoComplete="off"
//                 className={`${styles.label_phone__input} ${isError && !/^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(value) ? 'field_error' : ''}`}
//                 onKeyDown={handleKeyDown}
//                 placeholder="Телефон"
//                 type="tel"
//                 value={value}
//                 ref={(el) => {
//                     register('phone' as Path<T>).ref(el);
//                     setInputRef(el);
//                 }}
//             />
//         </label>
//     );
// };
var react_1 = __importStar(require("react"));
var FormFieldPhone_module_scss_1 = __importDefault(require("./FormFieldPhone.module.scss"));
var FormFieldPhone = function (props) {
    var id = props.id, register = props.register, isError = props.isError;
    var _a = (0, react_1.useState)('+7 (___) ___-__-__'), value = _a[0], setValue = _a[1];
    var formatPhoneNumber = function (input) {
        var phoneNumber = input.replace(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/, '+7 ($2) $3-$4-$5');
        return phoneNumber.length > 18 ? phoneNumber.slice(0, 18) : phoneNumber; // Ограничиваем длину
    };
    var handleChange = function (event) {
        var input = event.target.value.replace(/\D/g, ''); // Удаляем все нецифровые символы
        var formattedValue = formatPhoneNumber(input);
        setValue(formattedValue);
    };
    return (react_1.default.createElement("label", { className: FormFieldPhone_module_scss_1.default.label_phone, htmlFor: id },
        react_1.default.createElement("input", __assign({}, register('phone', {
            required: true,
            pattern: { value: /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/, message: 'Введите номер' },
        }), { autoComplete: "off", className: "".concat(FormFieldPhone_module_scss_1.default.label_phone__input, " ").concat(isError && !/^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(value) ? 'field_error' : ''), onChange: handleChange, placeholder: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D", type: "tel", value: value, ref: function (el) {
                register('phone').ref(el);
            } }))));
};
exports.FormFieldPhone = FormFieldPhone;
